import React from "react";

const OSSUserNameCell = ({ column, row }) => {
  const { dataKey, defaultValue = "" } = column;
  const value = row[dataKey];
  return (
    <>
      {value?.first_name
        ? `${value.first_name} ${value.last_name}`
        : defaultValue}
    </>
  );
};

export default OSSUserNameCell;
